import PropTypes from 'prop-types'
import {
  setPropTypes,
  withHandlers,
  withProps,
  withPropsOnChange,
  compose,
  withStateHandlers
} from 'recompose'

const noop = () => {}

export const withReduxFormField = withProps(props => ({
  onChange: props.input.onChange || noop,
  dirty: props.meta.dirty,
  invalid: props.meta.invalid,
  submitFailed: props.meta.submitFailed,
  // rename because error is used by the state decorator below
  formError: props.meta.error
}))

export const withErrorAndValueState = withStateHandlers(
  {
    error: null,
    file: ''
  },
  {
    setError: () => error => ({ error }),
    clearInputFile: () => file => ({ file: '' })
  }
)

// requires images (Array), onImageRemoved(id):Promise, onChange(Number)
export const withDeleteMedia = withHandlers({
  onDeleteMedia: props => id => {
    return props.onImageRemoved(id).then(res => {
      // notify redux form
      props.onChange(props.images.length - 1)
    })
  }
})

export const withFileUpload = withHandlers({
  onFileUploadChange: props => e => {
    const file = e.target.files[0]
    if (!/image/.test(file.type)) {
      props.setError('File is not a valid image.')
      return
    }
    const reader = new FileReader()
    reader.onerror = e => {
      console.log('File could not be read', e)
      props.setError('Error reading file')
      props.clearInputFile()
    }
    reader.onload = e => {
      props.onImageUploaded(file, e.target.result).then(() => {
        props.setError(null)
        // notify redux form
        props.onChange(++props.images.length)
      })
    }
    reader.readAsDataURL(file)
  }
})

export const withImageLimit = withPropsOnChange(
  ['images', 'maxImages'],
  props => {
    const { images, maxImages } = props
    return {
      isUploadVisible:
        maxImages === undefined || maxImages === 0 || images.length < maxImages
    }
  }
)

const DEFAULT_ERROR_TEXT = 'At least one image is required'
export const withError = withProps(
  ({
    dirty,
    submitFailed,
    invalid,
    error,
    formError,
    requiredErrorText = DEFAULT_ERROR_TEXT
  }) => {
    const hasError = Boolean(error || invalid || formError)
    return {
      hasError,
      errorText: error || (formError && requiredErrorText)
    }
  }
)

export const enhance = compose(
  setPropTypes({
    // func(file: File, dataUrl: String)
    onImageUploaded: PropTypes.func.isRequired,
    // func(imageId)
    onImageRemoved: PropTypes.func.isRequired,
    requiredErrorText: PropTypes.string,
    maxImages: PropTypes.number
  }),
  withReduxFormField,
  withErrorAndValueState,
  withFileUpload,
  withDeleteMedia,
  withImageLimit,
  withError
)

export default enhance



// WEBPACK FOOTER //
// ./src/services/mycharity/media/image-gallery.js